import React from 'react';
import HeroSlider from '../components/layout/HeroSlider';
import FeatureStrip from '../components/layout/FeatureStrip';
import DoctorsIntro from '../components/layout/DoctorsIntro';
import DoctorsGrid from '../components/layout/DoctorsGrid';
import MedicalUnits from '../components/layout/MedicalUnits';
import PartnersCarousel from '../components/layout/PartnersCarousel';
import { toUrl } from '../lib/config';


import AcnTurk from '../assets/images/partners/acnturk.png';
import Allianz from '../assets/images/partners/allianz.png';
import Axa from '../assets/images/partners/axa.png';
import Demir from '../assets/images/partners/demir.png';
import Doga from '../assets/images/partners/doga.png';
import Ethica from '../assets/images/partners/ethica.png';
import Generali from '../assets/images/partners/generali.png';
import Halkbank from '../assets/images/partners/halkbank.png';
import Isbank from '../assets/images/partners/isbank.png';
import Magdeburger from '../assets/images/partners/magdeburger.png';
import Mapfre from '../assets/images/partners/mapfre.png';
import Neova from '../assets/images/partners/neova.png';
import Nippon from '../assets/images/partners/nippon.png';
import NN from '../assets/images/partners/nn.png';
import QNB from '../assets/images/partners/qnb.png';
import Quick from '../assets/images/partners/quick.png';
import Unico from '../assets/images/partners/unico.png';
import Vakifbank from '../assets/images/partners/vakifbank.png';




const HomePage: React.FC = () => {

  // const units = [
  //   {
  //     title: "Nöroloji",
  //     text:
  //       "Uzman nöroloji kadromuzla geleceğe daha umutla bakabilirsiniz. Yenilikçi tedavi yöntemleriyle en kısa sürede tedavi odaklıdır.",
  //     icon: <img src={Brain} alt="Brain" /> //<i className="bi bi-broadcast" />,
  //   },
  //   {
  //     title: "Radyoloji",
  //     text:
  //       "MR, tomografi, röntgen gibi yüksek teknoloji görüntüleme yöntemlerimizle kesin ve doğru tanıları kısa sürede iletiriz.",
  //     icon: <img src={Radyoloji} alt="Radyoloji" />,
  //   },
  //   {
  //     title: "Ortopedi",
  //     text:
  //       "Uzman kadromuzla modern tedavi yöntemleri eşliğinde yüksek memnuniyetle hizmet veriyoruz.",
  //     icon: <img src={Ortopedi} alt="Ortopedi" />,
  //   },
  // ];

  const PARTNERS = [
    { src: Demir, alt: "Demir" },
    { src: Isbank, alt: "Türkiye İş Bankası" },
    { src: Mapfre, alt: "Mapfre Sigorta" },
    { src: Vakifbank, alt: "VakıfBank" },
    { src: Neova, alt: "Neova" },
    { src: Doga, alt: "Doğa Sigorta" },
    { src: Ethica, alt: "Ethica" },
    { src: Generali, alt: "Generali" },
    { src: Halkbank, alt: "Halkbank" },
    { src: Magdeburger, alt: "Magdeburger" },
    { src: Nippon, alt: "Nippon" },
    { src: NN, alt: "NN" },
    { src: QNB, alt: "QNB" },
    { src: Quick, alt: "Quick" },
    { src: Unico, alt: "Unico" },
    { src: Vakifbank, alt: "VakıfBank" },
    { src: AcnTurk, alt: "AcnTurk" },
    { src: Allianz, alt: "Allianz" },
    { src: Axa, alt: "Axa" },
  ];
  const [partners, setPartners] = React.useState<Array<{ src: string; alt: string }>>([]);
  const [loadingPartners, setLoadingPartners] = React.useState(false);


  const [doctors, setDoctors] = React.useState<Array<{ id: string | number; name: string; subtitle: string; photo: string; icon: React.ReactNode }>>([]);
  const [loadingDoctors, setLoadingDoctors] = React.useState(false);

  // Medical Units state
  const [muTitleLight, setMuTitleLight] = React.useState<string>('Hastanemizin');
  const [muTitleAccent, setMuTitleAccent] = React.useState<string>('Tıbbi Birimleri');
  const [muCTA, setMuCTA] = React.useState<{ label: string; href: string } | undefined>({ label: 'Tüm Birimler', href: '/tibbi-birimler' });
  const [muColumns, setMuColumns] = React.useState<number>(3);
  const [muShowDividers, setMuShowDividers] = React.useState<boolean>(true);
  const [muUnits, setMuUnits] = React.useState<Array<{ id?: string; title: string; text: string; icon: React.ReactNode }>>([]);
  const [loadingUnits, setLoadingUnits] = React.useState(false);

  React.useEffect(() => {
    let cancelled = false;
    const run = async () => {
      try {
        setLoadingDoctors(true);
        const res = await fetch(toUrl('/api/doctors/random?limit=4'));
        if (!res.ok) throw new Error('fetch_failed');
        const data = await res.json();
        const mapped = (Array.isArray(data) ? data : []).map((d: any, idx: number) => {
          const raw = d.portraitUrl || '';
          const normalized = /^https?:\/\//i.test(raw)
            ? raw
            : (raw.startsWith('/api/') ? raw : (raw ? `/api/media/${raw}` : ''));
          return ({
          id: d.id || idx,
          name: d.name || '',
          subtitle: d.shortTitle || '',
          photo: toUrl(normalized),
          icon: <span className="bi bi-gender-female"></span>,
          });
        });
        if (!cancelled) setDoctors(mapped);
      } catch {
        // bırak: doctors boş kalabilir, UI kırılmaz
      } finally {
        if (!cancelled) setLoadingDoctors(false);
      }
    };
    run();
    return () => { cancelled = true; };
  }, []);

  // Fetch Partners Carousel data
  React.useEffect(() => {
    let cancelled = false;
    const run = async () => {
      try {
        setLoadingPartners(true);
        const res = await fetch(toUrl('/api/anlasmali-partners'));
        if (!res.ok) throw new Error('fetch_failed');
        const data = await res.json();
        const list = Array.isArray(data) ? data.slice().sort((a:any,b:any)=> (a.orderIndex??0)-(b.orderIndex??0)) : [];
        const mapped = list.map((p:any) => {
          const raw = p.logoUrl || '';
          const normalized = /^https?:\/\//i.test(raw) ? raw : (raw.startsWith('/api/') ? raw : (raw ? `/api/media/${raw}` : ''));
          return { src: toUrl(normalized), alt: p.name || '' };
        });
        if (!cancelled) setPartners(mapped);
      } catch {
        // leave empty
      } finally {
        if (!cancelled) setLoadingPartners(false);
      }
    };
    run();
    return () => { cancelled = true; };
  }, []);

  // Fetch Medical Units (do not change colors; only take incoming data)
  React.useEffect(() => {
    let cancelled = false;
    const run = async () => {
      try {
        setLoadingUnits(true);
        const res = await fetch(toUrl('/api/medical-units'));
        if (!res.ok) throw new Error('fetch_failed');
        const data = await res.json();
        const payload = (Array.isArray(data) ? (data[0] || {}) : (data || {}));
        // Titles
        if (!cancelled) setMuTitleLight(payload.titleLight || 'Hastanemizin');
        if (!cancelled) setMuTitleAccent(payload.titleAccent || 'Tıbbi Birimleri');
        if (!cancelled) setMuCTA(payload.cta && payload.cta.label && payload.cta.href ? { label: payload.cta.label, href: payload.cta.href } : undefined);
        if (!cancelled) setMuColumns(Number(payload.columns || 3));
        if (!cancelled) setMuShowDividers(payload.showDividers !== false);
        const ImgWithFallbackMU: React.FC<{ src?: string; alt?: string }> = ({ src, alt }) => {
          const input = src || '';
          const raw = /^https?:\/\//i.test(input)
            ? input
            : (input.startsWith('/api/') ? input : (input ? `/api/media/${input}` : ''));
          const abs = /^https?:\/\//i.test(raw) ? raw : toUrl(raw);
          const [current, setCurrent] = React.useState(abs);
          return (
            <img
              src={current}
              alt={alt || ''}
              width={140}
              height={140}
              style={{ objectFit: 'contain', display: 'block' }}
              crossOrigin="anonymous"
              onError={(e) => {
                const cur = e.currentTarget.getAttribute('src') || '';
                const next = cur === abs ? raw : abs;
                if (next && next !== cur) e.currentTarget.src = next;
              }}
            />
          );
        };
        const items = Array.isArray(payload.items) ? payload.items.slice().sort((a:any,b:any)=> (a.orderIndex??0)-(b.orderIndex??0)) : [];
        const unitsMapped = items.map((it:any) => ({
          id: it.id,
          title: it.title || '',
          text: it.text || '',
          icon: <ImgWithFallbackMU src={it.iconUrl} alt={it.title || ''} />,
        }));
        if (!cancelled) setMuUnits(unitsMapped);
      } catch {
        // leave defaults
      } finally {
        if (!cancelled) setLoadingUnits(false);
      }
    };
    run();
    return () => { cancelled = true; };
  }, []);

  return (
    <>
      {/* Hero Slider Section */}
      <HeroSlider />

      {/* Feature Strip Section */}
      <FeatureStrip />

      {/* Doctors Intro Section */}
      <DoctorsIntro />

      {loadingDoctors ? (
        <section className="doctors-grid" aria-busy="true" aria-live="polite">
          <div className="container">
            <div style={{ padding: '24px 0', textAlign: 'center', color: '#6b7280' }}>Hekimler yükleniyor…</div>
          </div>
        </section>
      ) : (
        <DoctorsGrid items={doctors} />
      )}
      
      <MedicalUnits
        titleLight={muTitleLight}
        titleAccent={muTitleAccent}
        units={muUnits}
        cta={muCTA}
        columns={muColumns}
        showDividers={muShowDividers}
        bgColor="#2cadd2"          
        accentColor="#2ba87a"
        textColor="#ffffff"
      />

      {loadingPartners ? (
        <section className="partners" aria-busy="true" aria-live="polite">
          <div className="container">
            <div style={{ padding: '24px 0', textAlign: 'center', color: '#6b7280' }}>Kurum logoları yükleniyor…</div>
          </div>
        </section>
      ) : (
        <PartnersCarousel
          titleLight="Anlaşmalı"
          titleAccent="Kurumlar"
          partners={partners ? partners : PARTNERS}
          intervalMs={2000}
          accentColor="#2cadd2"   // MAVİ
        />
      )}


    </>
  );
};

export default HomePage;
